<p8-settings-page>
  <p8-settings-header [titlePath]="['Images', 'Editer']"></p8-settings-header>

  <p8-bdc-image-form *ngIf="image"
                     [url]="image.file"
                     [title]="image.title"
                     [description]="image.description">
  </p8-bdc-image-form>

  <p8-settings-footer>
    <button mat-raised-button
            color="accent"
            (click)="onSubmit()"
    >ENREGISTRER</button>
    <button mat-button (click)="onCancel()">RETOUR</button>
  </p8-settings-footer>
</p8-settings-page>
